(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const syncImage = (form) => {
    const choice = form.querySelector('input[name="id"]:checked');
    if (!choice || !choice.dataset.variantImage) return;
    const card = form.closest('.product-card');
    const product = form.closest('.main-product');
    const image = card ? card.querySelector('img') : product?.querySelector('.product-gallery img');
    if (!image) return;
    image.src = choice.dataset.variantImage;
    image.srcset = choice.dataset.variantSrcset;
    image.alt = choice.dataset.variantAlt;
    image.width = Number(choice.dataset.imageWidth);
    image.height = Number(choice.dataset.imageHeight);
  };
  const initialiseImages = (scope = document) => scope.querySelectorAll('[data-product-form]').forEach(syncImage);
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-variant-image]')) syncImage(event.target.closest('[data-product-form]'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseImages());
  else initialiseImages();
  document.addEventListener('shopify:section:load', (event) => initialiseImages(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
